[
  {
    "url": "https://mail.google.com/mail/u",
    "elements": [
      {
        "name": "Search recipient emails",
        "selector": ".nH.Hd[role='dialog'] form tr:first-child > td:nth-child(2) div[role='option']",
        "multiple": "true",
        "attributes": ["data-hovercard-id"]
      },
      {
        "name": "New Email Subject",
        "selector": ".nH.Hd[role='dialog'] form input[name='subject']",
        "attributes": ["value"]
      },
      {
        "name": "Sender and recipients emails",
        "selector": ".nH[role='main'] div[role='listitem']:last-child table tr:first-child td:first-child span[email]",
        "attributes": ["email"],
        "multiple": "true"
      },
      {
        "name": "Reply to email",
        "selector": ".oL.aDm.az9 span[email]",
        "attributes": ["email"],
        "multiple": "true"
      },
      {
        "name": "Subject",
        "selector": ".nH[role='main'] h2.hP"
      },
      {
        "name": "Add SW Button Compose",
        "scenario": {
          "name": "addSwButtonToGmailCompose",
          "container": ".nH.Hd[role='dialog'] table tr td:first-child h2 > div > span",
          "multiple": "true"
        }
      },
      {
        "name": "Add SW Button Letter",
        "scenario": {
          "name": "addSwButtonToGmailLetter",
          "container": ".c2 .gD"
        }
      },
      {
        "name": "Add SW AI Agent Button Compose",
        "scenario": {
          "name": "addSwAIAgentButtonToGmailCompose",
          "container": ".nH.Hd",
          "toolbarSelector": ".nH.Hd .aDh",
          "bodySelector": ".iN",
          "multiple": "true",
          "elementAfterWhichToInsertButton": ".gU.Up"
        }
      },
      {
        "name": "Add SW AI Agent Button Reply",
        "scenario": {
          "name": "addSwAIAgentButtonToGmailReply",
          "container": ".aoP.HM",
          "toolbarSelector": ".aoP.HM .IZ",
          "bodySelector": ".IG",
          "multiple": "true",
          "elementAfterWhichToInsertButton": ".gU.Up"
        }
      }
    ]
  }
]
